export default __webpack_public_path__ + "static/krowan-4dc44f71cc3d20269da64e0f8a1d282a.jpg";